import { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SyncIndicatorProps {
  lastSynced: Date | null;
  isSyncing: boolean;
  onRefresh: () => void;
}

function formatElapsed(date: Date): string {
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  if (seconds < 5) return 'ahora';
  if (seconds < 60) return `hace ${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  return `hace ${minutes}m`;
}

export function SyncIndicator({ lastSynced, isSyncing, onRefresh }: SyncIndicatorProps) {
  const [, setTick] = useState(0);

  // Re-render every 5s to update "hace Xs"
  useEffect(() => {
    const interval = setInterval(() => setTick((t) => t + 1), 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center gap-2 rounded-lg bg-gray-50 px-3 py-1.5 text-xs text-gray-500">
      <span
        className={cn(
          'h-2 w-2 rounded-full',
          isSyncing ? 'bg-yellow-400 animate-pulse' : 'bg-emerald-400'
        )}
      />
      <span>
        {isSyncing
          ? 'Sincronizando...'
          : lastSynced
            ? formatElapsed(lastSynced)
            : 'Conectando...'}
      </span>
      <button
        onClick={onRefresh}
        className="ml-0.5 rounded p-0.5 text-gray-400 hover:bg-gray-200 hover:text-gray-600 transition-colors"
        title="Refrescar ahora"
      >
        <RefreshCw className={cn('h-3.5 w-3.5', isSyncing && 'animate-spin')} />
      </button>
    </div>
  );
}
